(function () {

    'use strict';

    angular.module('asys')
        .config(stateConfig)
        .run(stateRun);

    stateConfig.$inject = [
        '$stateProvider',
        '$urlRouterProvider'
    ];
    function stateConfig($stateProvider, $urlRouterProvider) {
        var $delegateStateProvider = $stateProvider.state;

        $urlRouterProvider.otherwise('/einstieg/');

        $stateProvider.state = function (name, definition) {
            if (!definition.resolve) {
                definition.resolve = {};
            }

            return $delegateStateProvider.apply(this, arguments);
        };

        $stateProvider
            .state('fehler', {
                'abstract': true,
                url: '/fehler',
                data: {
                    pageTitle: 'WGV Tarifrechner'
                },
                params: {
                    reload: true,
                    message: null,
                    links: {}
                },
                views: {
                    main: {
                        templateUrl: 'fehler/main.html',
                        controller: 'FehlerSeiteController',
                        controllerAs: 'fehlerSeiteVm'
                    }
                }
            })
            .state('fehler.404', {
                url: '/404',
                parent: 'fehler',
                views: {
                    content: {
                        templateUrl: 'fehler/404.html'
                    }
                }
            })
            .state('fehler.wartung', {
                url: '/wartung',
                parent: 'fehler',
                views: {
                    content: {
                        templateUrl: 'fehler/wartung.html'
                    }
                }
            })
            .state('fehler.409', {
                url: '/409',
                parent: 'fehler',
                views: {
                    content: {
                        templateUrl: 'fehler/409.html'
                    }
                }
            })
            .state('fehler.login', {
                url: '/login',
                parent: 'fehler',
                views: {
                    content: {
                        templateUrl: 'fehler/login.html'
                    }
                }
            })
            .state('fehler.cookie', {
                url: '/cookie',
                parent: 'fehler',
                views: {
                    content: {
                        templateUrl: 'fehler/cookie.html'
                    }
                }
            })
            .state('einstieg', {
                url: '/einstieg/:angwkzname',
                data: {
                    pageTitle: 'WGV Tarifrechner',
                    clearAlerts: false
                },
                params: {
                    angwkzname: ''
                },
                views: {
                    main: {
                        template: '<ui-view/>',
                        controller: 'EinstiegController'
                    }
                },
                resolve: { /* @ngInject */
                    angebotModel: ['$q', '$stateParams', 'lodash', 'AngebotModel', 'AngebotKfzModel', 'IntegrationService', function ($q, $stateParams, _, AngebotModel, AngebotKfzModel, IntegrationService) {
                        var integrationParams = IntegrationService.getIntegrationParams(),
                            options = {
                                erzeugeNeuesAngebotImFehlerfall: !!integrationParams.angwkzname
                            },
                            angebotModel = AngebotModel.get();
                        if (!$stateParams.reload && _.get(angebotModel, 'angebot.angebotstyp')) {
                            return $q(function (resolve) {
                                resolve(angebotModel);
                            });
                        }
                        if (integrationParams.angmodus === 'ersatz') {
                            return AngebotKfzModel.erstelleNeuesAngebotErsatzgeschaeft(integrationParams.tarifauskunftsdatum, null, integrationParams.vertragsnummer, {
                                erzeugeNeuesAngebotImFehlerfall: false
                            });
                        } else {
                            return AngebotModel.ladeAngebotOderErstelleDummyAngebotModel(integrationParams.tarifauskunftsdatum, null, options);
                        }
                    }]
                }
            })
            .state('rechner', {
                'abstract': true,
                url: '',
                data: {
                    pageTitle: 'WGV Tarifrechner'
                },
                params: {
                    reload: true,
                    init: true,
                    angwkzname: ''
                },
                views: {
                    main: {
                        templateUrl: 'angebot/angebot.html',
                        controller: 'AngebotController',
                        controllerAs: 'angebotVm'
                    }
                },
                resolve: { /* @ngInject */
                    schluesselwerte: [function () {
                        return {};
                    }],
                    angebotSpezifischeWerte: [function () {
                        return {};
                    }]
                }
            })
            .state('rechner.gevo', {
                url: '/:angwkzname/ihr-anliegen',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Ihr Anliegen'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: [],
                    angwkzname: ''
                },
                views: {
                    content: {
                        templateUrl: 'reiter/gevo/reiterGeVo.html',
                        controller: 'ReiterGeVoController',
                        controllerAs: 'gevoVm'
                    }
                }
            })
            .state('rechner.fahrzeug', {
                url: '/:angwkzname/fahrzeugdaten',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Fahrzeugdaten'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: []
                },
                views: {
                    content: {
                        templateUrl: 'reiter/fahrzeug/reiterFahrzeug.html',
                        controller: 'ReiterFahrzeugController',
                        controllerAs: 'fzgVm'
                    }
                },
                resolve: {
                    refresh: ['$q', 'BasisAngebotService', 'AngebotModel', 'AngebotKfzService', function ($q, BasisAngebotService, AngebotModel, AngebotKfzService) {
                        var angebotModel = AngebotModel.get();

                        if (BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT')) {
                            return BasisAngebotService.refreshAngebot(angebotModel, {
                                shouldRefreshVertragsdaten: AngebotKfzService.shouldUpdateVertragsdaten(angebotModel)
                            });
                        } else {
                            return $q.resolve(angebotModel.angebot);
                        }
                    }]
                }
            })
            .state('rechner.tarifmerkmale', {
                url: '/:angwkzname/tarifdaten',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Ihre Angaben'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: [],
                    angwkzname: ''
                },
                views: {
                    content: {
                        templateUrl: 'reiter/tarifmerkmale/reiterTarifmerkmale.html',
                        controller: 'ReiterTarifmerkmaleController',
                        controllerAs: 'tarifVm'
                    }
                },
                resolve: {
                    refresh: ['BasisAngebotService', 'AngebotModel', function (BasisAngebotService, AngebotModel) {
                        var angebotModel = AngebotModel.get();

                        return BasisAngebotService.refreshMandatUndTarifgruppe(angebotModel);
                    }],
                    sfkSondereinstufungZweitwagenFlags: ['AngebotKfzService', 'AngebotModel', function (AngebotKfzService, AngebotModel) {
                        var angebotModel = AngebotModel.get();

                        return AngebotKfzService.getSfkSondereinstufungZweitwagenFlags(angebotModel);
                    }],
                    angebotSpezifischeWerte: ['$q', 'AngebotKfzService', 'AngebotModel', function ($q, AngebotKfzService, AngebotModel) {
                        var angebotModel = AngebotModel.get();

                        return $q.all([
                            AngebotKfzService.getSfkKhKv(angebotModel),
                            AngebotKfzService.getSfkKhKv(angebotModel, true)
                        ]).then(function (data) {
                            return {
                                schadenfreiheitsklassen: {
                                    haftpflicht: data[0].klassenHaftpflicht,
                                    vollkasko: data[0].klassenVollkasko
                                },
                                schadenfreiheitsklassenZuGevo: {
                                    haftpflicht: data[1].klassenHaftpflicht,
                                    vollkasko: data[1].klassenVollkasko
                                }
                            };
                        });
                    }]
                }
            })
            .state('rechner.ergebnis', {
                url: '/:angwkzname/tarifauskunft',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Beitragsübersicht'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: [],
                    angwkzname: '',
                    berechnen: true
                },
                views: {
                    content: {
                        templateUrl: 'reiter/ergebnis/reiterErgebnis.html',
                        controller: 'ReiterErgebnisController',
                        controllerAs: 'ergebnisVm'
                    }
                }
            })
            .state('rechner.persoenlichedaten', {
                url: '/:angwkzname/persoenliche-daten',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Ihre Daten'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: []
                },
                views: {
                    content: {
                        templateUrl: 'reiter/persoenlichedaten/reiterPersoenlicheDaten.html',
                        controller: 'ReiterPersoenlicheDatenController',
                        controllerAs: 'persDatenVm'
                    }
                }
            })
            .state('rechner.antrag', {
                url: '/:angwkzname/antrag',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Antragsfragen'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: []
                },
                views: {
                    content: {
                        templateUrl: 'reiter/antrag/reiterAntrag.html',
                        controller: 'ReiterAntragController',
                        controllerAs: 'antragVm'
                    }
                },
                resolve: { /* @ngInject */
                    schluesselwerte: ['$q', 'AngebotModel', 'BasisAngebotService', 'SchluesselWerteUtilsService', function ($q, AngebotModel, BasisAngebotService, SchluesselWerteUtilsService) {
                        return $q(function (resolve, reject) {
                            var angebotModel = AngebotModel.get(),
                                schluesselwertePromises = [],
                                noopPromise = function () {
                                    return $q(function (resolve) {
                                        resolve([]);
                                    });
                                };

                            schluesselwertePromises.push(SchluesselWerteUtilsService.fetch('versicherungsunternehmen', {
                                params: {
                                    vuFilter: 'KFZ',
                                    ohneEigeneVu: false
                                }
                            }));

                            schluesselwertePromises.push(BasisAngebotService.isGevo(angebotModel.angebot, ['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG']) ?
                                SchluesselWerteUtilsService.fetch('fahrzeugartTb28', {
                                    params: {
                                        sort: 'bezeichnung'
                                    }
                                }) : noopPromise
                            );

                            schluesselwertePromises.push(BasisAngebotService.isGevo(angebotModel.angebot, ['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG']) ?
                                SchluesselWerteUtilsService.fetch('beziehungTb28', {
                                    params: {
                                        sort: 'bezeichnung'
                                    }
                                }) : noopPromise
                            );

                            return $q.all(schluesselwertePromises).then(function (schluesselwerte) {
                                return resolve({
                                    versicherungsunternehmen: schluesselwerte[0],
                                    fahrzeugartTb28: schluesselwerte[1],
                                    beziehungTb28: schluesselwerte[2]
                                });
                            });
                        });
                    }]
                }
            })
            .state('rechner.antragpruefen', {
                url: '/:angwkzname/antrag-pruefen',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Abschluss'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: []
                },
                views: {
                    content: {
                        templateUrl: 'reiter/antragpruefen/reiterAntragPruefen.html',
                        controller: 'ReiterAntragPruefenController',
                        controllerAs: 'antragPruefenVm'
                    }
                },
                resolve: { /* @ngInject */
                    angebotGespeichert: ['$q', 'AngebotModel', 'BasisAngebotService', function ($q, AngebotModel, BasisAngebotService) {
                        var angebotModel = AngebotModel.get();

                        return $q(function (resolve, reject) {
                            BasisAngebotService.speichere(angebotModel).then(function (data) {
                                if (data.angebot) {
                                    angebotModel.angebot = angular.merge({}, data.angebot);
                                }

                                resolve(true);
                            }).catch(function (error) {
                                if (error === 'ANGEBOT_NICHT_AENDERBAR') {
                                    resolve(true);
                                } else {
                                    reject(false);
                                }
                            });
                        });
                    }]
                }
            })
            .state('rechner.abschluss', {
                url: '/:angwkzname/abschluss',
                parent: 'rechner',
                data: {
                    pageTitle: 'WGV Tarifrechner | Abschluss'
                },
                params: {
                    formValidation: null,
                    ignoreFollowingCheck: null,
                    apiNachrichten: null,
                    alerts: []
                },
                views: {
                    content: {
                        templateUrl: 'reiter/abschluss/reiterAbschluss.html',
                        controller: 'ReiterAbschlussController',
                        controllerAs: 'abschlussVm'
                    }
                }
            });
    }

    stateRun.$inject = [
        '$rootScope',
        '$window',
        '$document',
        'lodash',
        'AppConfig',
        'ApiService',
        'NavigationService',
        'IntegrationService',
        'DeviceUtilsService',
        'HtmlUtilsService',
        'AlertService',
        'ExceptionHandlerService'
    ];
    function stateRun($rootScope, $window, $document, _, AppConfig, ApiService, NavigationService, IntegrationService, DeviceUtilsService, HtmlUtilsService, AlertService, ExceptionHandlerService) {
        NavigationService.setEntryStep('einstieg');
        AlertService.setStateActions(_.get(AppConfig, 'APP.alertStateActions'));

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var integrationParams = IntegrationService.getIntegrationParams(),
                angwkzname = toParams.angwkzname || integrationParams.angwkzname,
                angwkz = _.findKey(AppConfig.APP.wkzUrlMapping, function (val) { return val === angwkzname; }) || angwkzname;

            IntegrationService.setIntegrationParams({
                angwkzname: angwkzname,
                angwkz: angwkz,
                reload: false
            });
            if (NavigationService.isErrorStep(toState.name) && toParams.reload !== true) {
                return;
            }
            if (fromState.abstract && !NavigationService.isEntryStep(toState.name) && (toParams.init || NavigationService.isErrorStep(toState.name))) {
                event.preventDefault();
                return NavigationService.goToStep('einstieg', toParams);

            } else if (fromState.abstract) {
                NavigationService.showGroupToStep(toState.name);
                NavigationService.setActive(toState.name);

            } else if (NavigationService.isExitStep(fromState.name) && toParams.ignoreFollowingCheck !== true) {
                event.preventDefault();
                return $window.location.reload();
            }

            return;
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (_.get(toParams, 'data.scrollTop') !== false) {
                HtmlUtilsService.scrollTo($window.parent, 0);
            }

            if (NavigationService.isErrorStep(toState.name)) {
                return;
            }

            if (angular.isDefined(_.get(toState, 'data'))) {
                $rootScope.pageTitle = (toState.data.pageTitle || '');
            }

            NavigationService.showGroupToStep(toState.name);
        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            var step;

            error = error || {};

            if (ApiService.isValidationError(error.status)) {
                if (NavigationService.isEntryStep(toState.name)) {
                    return NavigationService.goToStep('fehler.409', {
                        reload: false
                    });
                }

                return;
            }
            ExceptionHandlerService.logRemote(_.isEmpty(error) ? new Error('app.state.js $stateChangeError ' + [
                fromState.name,
                toState.name
            ].join(' -> ')) : error, true);

            if (error.status === -1 || ApiService.isHttpError(error.status) || fromState.abstract) {
                step = 'fehler.404';

                ApiService.isMaintenance().then(function (isMaintenance) {
                    if (isMaintenance) {
                        step = 'fehler.wartung';
                    }
                }).finally(function () {
                    NavigationService.goToStep(step, {
                        reload: false
                    });
                });
            }
        });

        $rootScope.$on('$viewContentLoaded', function (event, name) {
            var element,
                viewHistory = NavigationService.getViewHistory();
            if (viewHistory) {
                element = $document.find('h1')[0] || $document.find('asys-header')[0];

                if (element) {
                    element.setAttribute('tabIndex', -1);
                    element.focus();
                }
            }

            NavigationService.setViewHistory(name);
        });
    }
})();
